import { BaseOption } from 'ui/selects';
import { comparatorOptions } from '../constants';

export type PropertyBase = {
  Suffix: string;
  dataType: string;
  id: string;
  label: string;
  value: string;
  values: any[];
};

export const getPropertyByNameFromProperties = (
  propertiesObject: BaseOption[],
  propertyName: string,
) => {
  return propertiesObject?.filter((p) => p.value === propertyName)?.[0] || {};
};

export const getComparatorsBasedOnDataType = (
  dataType: string,
  isLowCardinalityProperty: boolean,
  selectedProperty: PropertyBase,
) => {
  const comparators = dataType
    ? comparatorOptions[dataType]
    : selectedProperty?.dataType && comparatorOptions[selectedProperty?.dataType];

  /** Remove startsWith from comparator options if property is low cardinality */
  return comparators && isLowCardinalityProperty
    ? comparators.filter((comp) => comp.id !== 'startsWith')
    : comparators;
};
